import { Routes, Route } from "react-router-dom";
import { LayoutDashboard, Store, Package, CreditCard, KeyRound, ScrollText } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import AdminOverview from "./AdminOverview";
import AdminRestaurants from "./AdminRestaurants";
import AdminPlans from "./AdminPlans";
import { AdminPayments, AdminAudit } from "./AdminLists";
import AdminRazorpay from "./AdminRazorpay";

const NAV = [
  { to: "/admin", key: "admin-overview", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/restaurants", key: "admin-restaurants", label: "Restaurants", icon: Store },
  { to: "/admin/plans", key: "admin-plans", label: "Plans", icon: Package },
  { to: "/admin/payments", key: "admin-payments", label: "Payments", icon: CreditCard },
  { to: "/admin/razorpay", key: "admin-razorpay", label: "Payment settings", icon: KeyRound },
  { to: "/admin/audit", key: "admin-audit", label: "Audit log", icon: ScrollText },
];

export default function AdminDashboard() {
  return (
    <DashboardLayout nav={NAV}>
      <Routes>
        <Route index element={<AdminOverview />} />
        <Route path="restaurants" element={<AdminRestaurants />} />
        <Route path="plans" element={<AdminPlans />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="razorpay" element={<AdminRazorpay />} />
        <Route path="audit" element={<AdminAudit />} />
      </Routes>
    </DashboardLayout>
  );
}
